/**
 * @module api-web:financialAffairs/generalLedger/data/accountingCalendar
 */
import service from '@/service'

/**
 * 查询 财务-总账-资料-会计政策
 * @param {object} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/fin/gl/data/finAccountPolicy/getList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {number} id
 * @description 详情
 */
export function info(id) {
  return service['api-web']({
    url: '/fin/gl/data/finAccountPolicy/info',
    method: 'get',
    params: { id }
  })
}
